// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"style_tableRow__YAQry"};